/**
 * Alert manager for use outside of React components
 * This allows API services to add and clear alerts
 */

type AlertCallback = (action: 'clearErrors' | 'addAlert', data?: any) => void;

export interface Alert {
    id: string;
    type: 'success' | 'error' | 'warning' | 'info';
    message: string;
}

class AlertManager {
    private callback: AlertCallback | null = null;

    /**
     * Register a callback function to be called when alerts need to be managed
     * This should be called from the AlertContext
     */
    registerCallback(callback: AlertCallback) {
        this.callback = callback;
    }

    /**
     * Add an alert from services
     */
    addAlert(type: 'success' | 'error' | 'warning' | 'info', message: string) {
        if (this.callback) {
            this.callback('addAlert', { type, message });
        }
    }

    /**
     * Clear error alerts
     * This can be called from API services
     */
    clearErrorAlerts() {
        if (this.callback) {
            this.callback('clearErrors');
        }
    }
}

// Export a singleton instance
export const alertManager = new AlertManager();
